/*
  PW Sticky Add-to-Cart
  Gehört zu snippets/pw-sticky-add-to-cart.liquid + assets/pw-sticky-add-to-cart.css
  (gerendert von der main-product Section, Einstellung "Sticky Add-to-Cart")

  Sichtbarkeit: erscheint (Fade-in), sobald der reguläre Add-to-Cart-Button
  der main-product Section nach oben aus dem Viewport gescrollt ist; blendet
  aus, sobald der Footer in den Viewport kommt (kein Überlappen).

  Add-to-Cart: klickt den regulären Button an – Menge und
  properties[_vd_tiers] des Staffelpreis-Features greifen dadurch
  automatisch, ohne eigene Cart-Logik.

  Variantenwechsel: hört auf das VARIANT_CHANGE-Event der product-variants
  Komponente und aktualisiert Bild, Preis, Streichpreis, Rabatt-Badge und
  Grundpreis aus der eigenen JSON-Varianten-Map.
*/
(function () {
  'use strict';

  if (customElements.get('pw-sticky-atc')) return;

  var FOOTER_SELECTOR = '.shopify-section-group-footer-group, .site-footer-container, footer';

  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  class PwStickyAtc extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      // Theme-Editor: bei Section-Reload alte, bereits nach <body>
      // verschobene Instanzen entfernen
      var self = this;
      document.querySelectorAll('pw-sticky-atc').forEach(function (el) {
        if (el !== self) el.remove();
      });

      this.productPage = document.querySelector('[data-js-product-component].main-product');
      this.mainButton = this.productPage
        ? this.productPage.querySelector('[data-js-product-add-to-cart]')
        : null;

      if (!this.mainButton) return;

      this.button = this.querySelector('[data-pw-satc-button]');
      this.buttonText = this.button.querySelector('.button__text');
      this.defaultButtonText = this.buttonText.textContent;
      this.imageEl = this.querySelector('[data-pw-satc-image]');
      this.priceEl = this.querySelector('[data-pw-satc-price]');
      this.compareEl = this.querySelector('[data-pw-satc-compare]');
      this.badgeEl = this.querySelector('[data-pw-satc-badge]');
      this.unitEl = this.querySelector('[data-pw-satc-unit]');

      var dataEl = this.querySelector('[data-pw-satc-variants]');
      var data = { variants: {} };
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) { /* Karte bleibt auf initialem Liquid-Stand */ }
      this.variantsMap = data.variants || {};

      // Aus der Section heraus an <body> hängen, damit kein Ancestor mit
      // transform/filter das position:fixed aushebeln kann (gleiches
      // Vorgehen wie die Theme-eigene sticky-add-to-cart Komponente).
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }

      this.footer = document.querySelector(FOOTER_SELECTOR);

      this.bindScroll();
      this.bindClick();
      this.bindVariantChange();
      this.updateVisibility();
    }

    bindScroll() {
      var self = this;
      var ticking = false;

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          self.updateVisibility();
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    updateVisibility() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      // Regulärer Button muss nach oben aus dem Viewport gescrollt sein
      var buttonRect = this.mainButton.getBoundingClientRect();
      var buttonScrolledPast = buttonRect.bottom < 0;

      // Footer darf noch nicht sichtbar sein
      var footerAway = true;
      if (this.footer) {
        footerAway = this.footer.getBoundingClientRect().top > viewportHeight;
      }

      this.classList.toggle('is-visible', buttonScrolledPast && footerAway);
    }

    bindClick() {
      var self = this;

      this.button.addEventListener('click', function () {
        if (self.button.disabled) return;
        self.mainButton.click();
      });

      // Ladezustand des regulären Buttons spiegeln (Klasse "working")
      new MutationObserver(function () {
        self.button.classList.toggle(
          'working',
          self.mainButton.classList.contains('working')
        );
      }).observe(this.mainButton, { attributes: true, attributeFilter: ['class'] });
    }

    bindVariantChange() {
      var self = this;
      var productVariants = this.productPage.querySelector('product-variants[data-main-product-variants]');
      if (!productVariants) return;

      productVariants.addEventListener('VARIANT_CHANGE', function () {
        // Kurz warten, bis component-product-form.js input[name="id"]
        // aktualisiert hat (gleiches Timing wie volume-discount-selector-pdp.js)
        setTimeout(function () {
          var idInput = self.productPage.querySelector('input[name="id"]');
          if (!idInput) return;
          var variant = self.variantsMap[String(idInput.value)];
          if (variant) self.renderVariant(variant);
        }, 60);
      });
    }

    renderVariant(variant) {
      if (this.imageEl && variant.image) {
        this.imageEl.src = variant.image;
      }

      if (this.priceEl) {
        this.priceEl.textContent = formatMoney(variant.price);
      }

      var hasDiscount = variant.compareAtPrice > variant.price;
      if (this.compareEl) {
        this.compareEl.hidden = !hasDiscount;
        this.compareEl.textContent = hasDiscount ? formatMoney(variant.compareAtPrice) : '';
      }
      if (this.badgeEl) {
        this.badgeEl.hidden = !hasDiscount;
        if (hasDiscount) {
          var percent = Math.round((1 - variant.price / variant.compareAtPrice) * 100);
          this.badgeEl.textContent = '-' + percent + '%';
        }
      }

      if (this.unitEl) {
        if (variant.unitPrice > 0) {
          var ref = variant.unitPriceRef && variant.unitPriceRef != 1 ? variant.unitPriceRef + ' ' : '';
          this.unitEl.textContent = '(' + formatMoney(variant.unitPrice) + '/' + ref + variant.unitPriceUnit + ')';
          this.unitEl.hidden = false;
        } else {
          this.unitEl.hidden = true;
        }
      }

      if (variant.available) {
        this.button.disabled = false;
        this.buttonText.textContent = this.defaultButtonText;
      } else {
        this.button.disabled = true;
        this.buttonText.textContent = this.dataset.soldOutText || this.defaultButtonText;
      }
    }
  }

  customElements.define('pw-sticky-atc', PwStickyAtc);

  // Theme-Editor: main-product Section neu gerendert oder entfernt →
  // auch die nach <body> verschobene Instanz entfernen
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.classList.contains('mount-product-page')) {
      document.querySelectorAll('pw-sticky-atc').forEach(function (el) {
        el.remove();
      });
    }
  });
})();
